'use client';

import ActivityBanner from '@/app/(activity)/components/ActivityBanner';
import { ResponsiveContext } from '@/components/Responsive/ResponsiveProvider';
import logger from '@/utils/client-logger';
import { EPlatform } from '@/utils/enums/platform-enum';
import { useMount, useUnmount } from 'ahooks';
import { memo, useContext, useEffect } from 'react';
import usePageTrack from '../hooks/usePageTrack';

interface IBannerBProps {
  banner: any;
}
function BannerB({ banner }: IBannerBProps) {
  const { deviceType } = useContext(ResponsiveContext);
  // 使用deviceType判断是否在App内
  const isInApp = [EPlatform.IOS, EPlatform.ANDROID].includes(deviceType);
  const { bannerRef, trackPageView, trackPageLeave, trackBannerClick } = usePageTrack({ banner });
  const handleBannerClick = (data: any) => {
    // console.log(data);
    logger.log('BannerB clicked:', data);
    trackBannerClick();
  };
  useMount(() => {
    trackPageView();
  });
  useUnmount(() => {
    trackPageLeave();
  });
  // APP内时监听appView事件（埋点相关）
  useEffect(() => {
    if (isInApp) {
      window.addEventListener('appView', trackPageView);
      return () => {
        window.removeEventListener('appView', trackPageView);
      };
    }
  }, [isInApp, trackPageView]);
  return (
    <div ref={bannerRef}>
      <ActivityBanner
        data={banner}
        aspectRatio={banner.aspectRatio}
        onBannerClick={handleBannerClick}
      />
    </div>
  );
}
export default memo(BannerB);
